





































import CtrlButton from "@/components/parts/CtrlButton.vue";
import WindowFrame from "../WindowFrame.vue";
import WindowMixin from "../WindowMixin.vue";

import { Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { Component, Mixins } from "vue-mixin-decorator";

@Component({
  components: {
    CtrlButton,
    WindowFrame
  }
})
export default class DropZipWindow extends Mixins<WindowMixin>(WindowMixin) {
  @Action("windowClose") private windowClose: any;
  @Action("windowOpen") private windowOpen: any;
  @Action("doImport") private doImport: any;
  @Getter("dropZipList") private dropZipList: any;
  @Getter("dropZipRoomCreate") private dropZipRoomCreate: any;

  private saveDataList: any[] = [];

  commit(): void {
    // zipデータの配列のマージ先
    const importData: any = {
      publicData: null,
      delKeyList: [],
      addObjList: [],
      dropZipRoomCreate: this.dropZipRoomCreate
    };

    // zipデータをマージする
    // TODO とりあえず、インポートするデータの取捨選択は考慮しない（第一リリース仕様）
    this.dropZipList.forEach(
      ({ fileName, saveData }: { fileName: string; saveData: any }) => {
        const publicData: any = saveData.public;
        const dataVersion: string = saveData.dataVersion;

        // const delKeyList: string[] = saveData.delKeyList;
        // const addObjList: any[] = saveData.addObjList;

        // TODO セーブデータの互換性の処理

        // publicデータのマージ（先勝ち）
        if (!importData.publicData) {
          // TODO 本当はもっと細かい単位で処理したい
          importData.publicData = publicData;
        }

        // // 削除リストのマージ
        // delKeyList.forEach(delKey => {
        //   if (importData.delKeyList.indexOf(delKey) !== -1) return;
        //   importData.delKeyList.push(delKey);
        // });
        //
        // // 追加リストのマージ
        // addObjList.forEach(addObj => {
        //   const index = importData.addObjList.findIndex((impAddObj: any) => {
        //     return JSON.stringify(addObj) === JSON.stringify(impAddObj);
        //   });
        //   if (index !== -1) return;
        //   importData.addObjList.push(addObj);
        // });
      }
    );
    this.doImport(importData);
    this.windowClose("private.display.dropZipWindow");
  }
  cancel(): void {
    this.windowClose("private.display.dropZipWindow");
  }
  allSelect(index: number): void {
    const useList: any[] = this.saveDataList[index].useList;
    useList.forEach((useObj, index: number) => {
      useObj.isUse = true;
      useList.splice(index, 1, useObj);
    });
  }
  allDisSelect(index: number): void {
    const useList: any[] = this.saveDataList[index].useList;
    useList.forEach((useObj, index: number) => {
      useObj.isUse = false;
      useList.splice(index, 1, useObj);
    });
  }

  @Watch("dropZipList")
  onChangeStoreZipList(dropZipList: any[]) {
    this.saveDataList = [];
    if (!dropZipList) {
      return;
    }
    dropZipList.forEach(saveDataObj => {
      const useList = [];
      const publicData = saveDataObj.saveData.public;
      if (publicData.setting) {
        useList.push({
          label: "設定情報(マス目表示、回転マーカーの表示など)",
          isUse: true,
          target: "setting"
        });
      }
      if (publicData.room) {
        useList.push({
          label: "部屋情報(継続卓なら必須)",
          isUse: true,
          target: "room"
        });
      }
      if (publicData.chat) {
        useList.push({
          label: "チャット履歴(部屋情報とセットで)",
          isUse: true,
          target: "chat"
        });
      }
      if (publicData.image) {
        useList.push({ label: "画像情報", isUse: true, target: "image" });
      }
      if (publicData.map) {
        useList.push({
          label: "マップ情報(画像情報とセットで)",
          isUse: true,
          target: "map"
        });
      }
      if (publicData.mapMask) {
        useList.push({
          label: "マップマスク情報",
          isUse: true,
          target: "mapMask"
        });
      }
      if (publicData.character) {
        useList.push({
          label: "キャラクター情報(画像情報とセットで)",
          isUse: true,
          target: "character"
        });
      }
      if (publicData.chit) {
        useList.push({
          label: "チット情報(画像情報とセットで)",
          isUse: true,
          target: "chit"
        });
      }
      if (publicData.publicMemo) {
        useList.push({
          label: "共有メモ",
          isUse: true,
          target: "publicMemo"
        });
      }
      this.saveDataList.push({
        fileName: saveDataObj.fileName,
        useList: useList,
        saveData: saveDataObj.saveData
      });
    });
  }
}
